export const LogoImg = '/parking.png'
export const AddImg = '/img/add.png'
export const BoxImg = '/img/box.png'
export const CylinderImg = '/img/cylinder.png'
export const DeleteImg = '/img/delete.png'
export const EditImg = '/img/edit.png'
